var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('Splash'),_c('About'),_c('Expertise'),_c('Portfolio'),_c('Contact')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }